
import { Vue, Component } from 'vue-property-decorator'

const config = {
  name: 'c-radio-button-icon'
}

@Component(config)
export default class CRadioButtonIcon extends Vue {}
